<template>
  <div class="pa-4">
    <!-- Botón Volver -->
    <div class="d-flex align-center mb-3">
      <v-btn @click="$router.back()" class="back-btn">
        <v-icon left>mdi-arrow-left</v-icon>
        VOLVER
      </v-btn>
    </div>

    <v-col cols="12" class="pa-0">
      <v-card class="rounded-lg elevation-3 overflow-hidden">
        <!-- Toolbar Header Principal estilo Cliente/Inspección -->
        <v-toolbar height="58" color="secondary" dark flat class="px-3">
          <div class="d-flex align-center">
            <v-icon left size="26">mdi-file-excel-box</v-icon>
            <span class="text-h6 font-weight-medium">
              Importar Archivo Excel de Criterios de Aceptación
            </span>
            <v-chip
              small
              color="white"
              text-color="secondary"
              class="font-weight-bold ml-3 px-3 elevation-1"
              style="font-size: 0.95rem; height: 32px"
            >
              <v-icon left size="18" color="secondary"
                >mdi-clipboard-check</v-icon
              >
              Total: {{ Item || 0 }}
            </v-chip>
          </div>

          <v-spacer></v-spacer>

          <!-- Botón de Ayuda con Tooltip -->
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-1 btn-circle-tooltip"
                icon
                dark
                target="_blank"
                :href="global.helpdesk_url + 'importar_datos_criterios'"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon size="25" color="amber lighten-2"
                  >mdi-help-circle-outline</v-icon
                >
              </v-btn>
            </template>
            <span>¿Necesitas ayuda?</span>
          </v-tooltip>
        </v-toolbar>

        <v-card-text class="pa-4 pa-md-5">
          <!-- SECCIÓN 1: INSTRUCCIONES Y GUÍA DE PASOS -->
          <div class="section-title d-flex align-center mb-3">
            <v-icon color="secondary" small class="mr-2"
              >mdi-clipboard-list-outline</v-icon
            >
            <span class="text-subtitle-1 font-weight-bold text--primary">
              Instrucciones y Requisitos de Importación
            </span>
          </div>

          <!-- Tarjetas de Pasos -->
          <v-row dense class="mb-4">
            <!-- Paso 1: Descargar plantilla -->
            <v-col cols="12" md="4" class="pa-2">
              <div
                class="step-card h-100 d-flex flex-column justify-space-between pa-4"
              >
                <div>
                  <div class="d-flex align-center justify-space-between mb-3">
                    <span class="step-number-badge step-badge-1">Paso 1</span>
                    <div class="step-icon-circle icon-circle-green">
                      <v-icon color="#10b981">mdi-file-excel</v-icon>
                    </div>
                  </div>
                  <h4
                    class="text-subtitle-1 font-weight-bold mb-1 text--primary"
                  >
                    Descargar Plantilla Base
                  </h4>
                  <p class="text-body-2 text--secondary mb-3">
                    Descarga el formato Excel oficial para organizar y registrar
                    los criterios de aceptación con la estructura adecuada.
                  </p>
                </div>
                <v-btn
                  color="primary"
                  depressed
                  class="rounded-lg text-none font-weight-bold elevation-1 w-100"
                  @click="download"
                >
                  <v-icon left size="20">mdi-download</v-icon>
                  Descargar Plantilla (.xls)
                </v-btn>
              </div>
            </v-col>

            <!-- Paso 2: Columnas y validación previa -->
            <v-col cols="12" md="4" class="pa-2">
              <div
                class="step-card h-100 d-flex flex-column justify-space-between pa-4"
              >
                <div>
                  <div class="d-flex align-center justify-space-between mb-3">
                    <span class="step-number-badge step-badge-2">Paso 2</span>
                    <div class="step-icon-circle icon-circle-orange">
                      <v-icon color="#f97316">mdi-format-header-pound</v-icon>
                    </div>
                  </div>
                  <div class="d-flex align-center mb-1">
                    <h4
                      class="text-subtitle-1 font-weight-bold text--primary mr-2"
                    >
                      Estructura de Datos
                    </h4>
                    <v-chip
                      x-small
                      color="error"
                      text-color="white"
                      class="font-weight-bold"
                    >
                      Obligatorio
                    </v-chip>
                  </div>
                  <p class="text-body-2 text--secondary mb-0">
                    Mantén las columnas de la plantilla sin alterar nombres ni
                    posiciones para garantizar la correcta validación de los
                    criterios.
                  </p>
                </div>
                <div class="step-note mt-3 pa-2 rounded d-flex align-center">
                  <v-icon small color="error" class="mr-1"
                    >mdi-alert-circle</v-icon
                  >
                  <span class="text-caption font-weight-medium"
                    >El archivo se validará automáticamente al subirse</span
                  >
                </div>
              </div>
            </v-col>

            <!-- Paso 3: Validación y navegación -->
            <v-col cols="12" md="4" class="pa-2">
              <div
                class="step-card h-100 d-flex flex-column justify-space-between pa-4"
              >
                <div>
                  <div class="d-flex align-center justify-space-between mb-3">
                    <span class="step-number-badge step-badge-3">Paso 3</span>
                    <div class="step-icon-circle icon-circle-teal">
                      <v-icon color="#0d9488">mdi-shield-check</v-icon>
                    </div>
                  </div>
                  <div class="d-flex align-center mb-1">
                    <h4
                      class="text-subtitle-1 font-weight-bold text--primary mr-2"
                    >
                      Verificar en Criterios
                    </h4>
                    <v-chip
                      x-small
                      color="teal"
                      text-color="white"
                      class="font-weight-bold"
                    >
                      Navegación
                    </v-chip>
                  </div>
                  <p class="text-body-2 text--secondary mb-3">
                    Una vez importado el archivo, podrás visualizar y gestionar
                    todos los registros en el módulo de criterios de aceptación.
                  </p>
                </div>
                <v-btn
                  outlined
                  color="secondary"
                  class="rounded-lg text-none font-weight-bold elevation-0 w-100"
                  @click="irAcriterios"
                >
                  <v-icon left size="18">mdi-arrow-top-right</v-icon>
                  Ir a Criterios de Aceptación
                </v-btn>
              </div>
            </v-col>
          </v-row>

          <!-- SECCIÓN 2: ZONA DE CARGA DROPZONE -->
          <div class="section-title d-flex align-center mb-3">
            <v-icon color="secondary" small class="mr-2"
              >mdi-cloud-upload-outline</v-icon
            >
            <span class="text-subtitle-1 font-weight-bold text--primary">
              Carga y Procesamiento del Archivo
            </span>
          </div>

          <v-card
            outlined
            class="upload-container-card rounded-lg overflow-hidden mb-3"
          >
            <!-- Barra superior del contenedor de carga -->
            <div
              class="upload-header-bar px-4 py-3 d-flex align-center justify-space-between flex-wrap"
            >
              <div class="d-flex align-center">
                <v-icon color="secondary" class="mr-2"
                  >mdi-clipboard-check-outline</v-icon
                >
                <span class="font-weight-bold text-subtitle-2 text--primary">
                  Criterios en el sistema:
                </span>
                <v-chip
                  small
                  color="secondary"
                  text-color="white"
                  class="font-weight-bold ml-2 px-3 elevation-1"
                >
                  {{ Item || 0 }}
                </v-chip>
              </div>
              <div
                class="d-flex align-center text-caption text--secondary mt-1 mt-sm-0"
              >
                <v-icon small class="mr-1" color="grey darken-1"
                  >mdi-file-excel-box</v-icon
                >
                <span
                  >Formatos soportados: <strong>.xls, .xlsx</strong> (Máx. 12
                  MB)</span
                >
              </div>
            </div>

            <v-divider></v-divider>

            <!-- Zona Interactiva de Dropzone -->
            <div class="pa-4 pa-md-5">
              <vue-dropzone
                id="customdropzone"
                ref="dropzone"
                :options="dropzoneOptions"
                :include-styling="true"
                :useCustomSlot="true"
                v-on:vdropzone-sending="sendingEvent"
                v-on:vdropzone-success="uploadSuccess"
              >
                <div class="dropzone-custom-content">
                  <div class="upload-icon-wrapper mb-3">
                    <v-icon size="46" color="#374151">mdi-cloud-upload</v-icon>
                  </div>
                  <h3
                    class="dropzone-custom-title text-h6 font-weight-bold mb-1 text--primary"
                  >
                    Arrastra tu archivo Excel aquí
                  </h3>
                  <p
                    class="dropzone-custom-subtitle text-body-2 text--secondary mb-4"
                  >
                    o haz clic en esta área para buscarlo en tu equipo
                  </p>
                  <div
                    class="d-inline-flex align-center select-file-chip py-2 px-4 rounded-pill"
                  >
                    <v-icon small left color="primary">mdi-paperclip</v-icon>
                    <span class="text-caption font-weight-bold primary--text"
                      >Explorar Archivo</span
                    >
                  </div>
                </div>
              </vue-dropzone>
            </div>
          </v-card>

          <!-- Barra de Acciones y Notificaciones -->
          <div class="d-flex justify-space-between align-center flex-wrap pt-2">
            <div
              class="d-flex align-center text-caption text--secondary mb-2 mb-sm-0"
            >
              <v-icon x-small color="grey darken-1" class="mr-1"
                >mdi-information-outline</v-icon
              >
              Una vez procesado el archivo, se mostrará una ventana con el
              resultado de la importación.
            </div>
            <div class="d-flex align-center">
              <v-btn
                text
                color="secondary"
                class="text-none font-weight-bold mr-2"
                @click="cargarCriterios"
              >
                <v-icon left small>mdi-refresh</v-icon>
                Actualizar Contador
              </v-btn>
              <v-btn
                outlined
                color="secondary"
                class="text-none font-weight-bold rounded-lg"
                @click="$router.back()"
              >
                <v-icon left small>mdi-arrow-left</v-icon>
                Regresar
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>

      <!-- Diálogo de Alerta de Respuesta -->
      <dialogalert
        :color="color"
        :icono="icono"
        :titulo="titulo"
        :mensaje="mensaje"
        :dialog="dialog"
        @dialog="dialog = $event"
      />
    </v-col>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import dialogalert from "@/components/dialogalert.vue";
import { mapGetters, mapActions } from "vuex";
import global from "../global";
import router from "@/router";

export default {
  name: "ImportarCriterios",
  components: {
    vueDropzone: vue2Dropzone,
    dialogalert,
  },
  created() {
    this.cargarCriterios();
  },
  data() {
    return {
      global: global,
      dialog: false,
      color: "",
      icono: "",
      titulo: "",
      mensaje: "",
      events: [],
      input: "Verificar el excel antes de subir",
      nonce: 0,
      dropzoneOptions: {
        url: global.ruta_api + "importar/criterio",
        maxFilesize: 12,
        headers: {
          "Cache-Control": null,
          "X-Requested-With": null,
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
        },
      },
    };
  },
  computed: {
    timeline() {
      return this.events.slice().reverse();
    },
    ...mapGetters("importarcriterio", ["Item"]),
  },
  methods: {
    ...mapActions("nav", ["CargarMenu"]),
    ...mapActions("importarcriterio", ["cargarCriterios"]),
    sendingEvent(file, xhr, formData) {
      formData.append("id_cliente", localStorage.getItem("idcliente"));
      formData.append("id_usuario", localStorage.getItem("id"));
    },
    uploadSuccess: function (file, response) {
      var cadenas = response.split("&&&&");
      if (cadenas.length > 1) {
        var respuesta = cadenas[1].split("<br>");
        this.color = "error";
        this.icono = "mdi-cloud-alert";
        this.titulo = "Error al Cargar Datos";
        this.mensaje = respuesta;
      } else {
        var respuesta = response.split("<br>");
        this.color = "success";
        this.icono = "mdi-checkbox-marked-circle";
        this.titulo = "Excel cargado Exitosamente";
        this.mensaje = respuesta;
      }
      this.dialog = true;
      this.cargarCriterios();
    },
    irAcriterios() {
      router.push("/criterioaceptacion");
    },
    download() {
      const url = "/docs/criterio_aceptacion.xls";
      window.location.href = url;
    },
  },
};
</script>

<style scoped>
/* Título de sección */
.section-title {
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 8px;
}

/* Tarjetas de pasos */
.step-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);
  transition: all 0.25s ease-in-out;
}

.step-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}

/* Badges numerados */
.step-number-badge {
  font-size: 0.75rem;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 20px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.step-badge-1 {
  background: #ecfdf5;
  color: #059669;
  border: 1px solid #a7f3d0;
}

.step-badge-2 {
  background: #fff7ed;
  color: #c2410c;
  border: 1px solid #fed7aa;
}

.step-badge-3 {
  background: #f0fdfa;
  color: #0f766e;
  border: 1px solid #99f6e4;
}

/* Contenedores de iconos de paso */
.step-icon-circle {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-circle-green {
  background: #ecfdf5;
}

.icon-circle-orange {
  background: #fff7ed;
}

.icon-circle-teal {
  background: #f0fdfa;
}

/* Notas de advertencia / pie de tarjeta */
.step-note {
  background: #fef2f2;
  color: #b91c1c;
  border-left: 3px solid #ef4444;
}

.step-note-teal {
  background: #f0fdf4;
  color: #15803d;
  border-left: 3px solid #22c55e;
}

/* Contenedor de subida Dropzone */
.upload-container-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
}

.upload-header-bar {
  background: #f8fafc;
}

/* Botón de ayuda circular del toolbar */
.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}
</style>

<style>
/* Estilos globales para la personalización de vue2Dropzone */
#customdropzone {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%) !important;
  border: 2px dashed #94a3b8 !important;
  border-radius: 14px !important;
  padding: 36px 20px !important;
  text-align: center !important;
  cursor: pointer !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  min-height: 220px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

#customdropzone:hover {
  border-color: #424242 !important;
  background: #f1f5f9 !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06) !important;
}

#customdropzone .upload-icon-wrapper {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #e2e8f0;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease, background-color 0.3s ease;
}

#customdropzone:hover .upload-icon-wrapper {
  transform: scale(1.08);
  background: #cbd5e1;
}

#customdropzone .select-file-chip {
  background: #e0e7ff;
  border: 1px solid #c7d2fe;
  transition: background-color 0.2s ease;
}

#customdropzone:hover .select-file-chip {
  background: #c7d2fe;
}

#customdropzone .dz-preview {
  width: 140px !important;
  height: 160px !important;
  display: inline-block !important;
  margin: 12px !important;
}

#customdropzone .dz-preview .dz-image {
  border-radius: 12px !important;
  overflow: hidden !important;
}

#customdropzone .dz-preview .dz-image > div {
  width: inherit !important;
  height: inherit !important;
  border-radius: 12px !important;
  background-size: contain !important;
}

#customdropzone .dz-preview .dz-details {
  background-color: #374151 !important;
  border-radius: 8px !important;
  color: #ffffff !important;
}
</style>
